export function validate(values) {
  const errors = {};

  if (!values.email) errors.email = 'Required';

  if (!values.password) errors.password = 'Required';

  return errors;
}



/** WEBPACK FOOTER **
 ** ./src/containers/LoginPage/validate.js
 **/